module.exports = __webpack_public_path__ + "img/gzhj_05.624dbee9.jpg";